import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';
// third-party
import { Chance } from 'chance';
import jwtDecode from 'jwt-decode';
// reducer - state management
import { LOGIN, LOGOUT } from 'store/reducers/actions';
import authReducer from 'store/reducers/auth';
// project-imports
import Loader from 'components/Loader';
import axios from 'utils/axios';
import { APP_DEFAULT_PATH_BASE_URL } from '../config';

const chance = new Chance();
// constant
const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};
//alert('test');
const verifyToken = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};
const setSession = (serviceToken) => {
  if (serviceToken) {
    localStorage.setItem('serviceToken', serviceToken);
    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
  } else {
    localStorage.removeItem('serviceToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

const setSession2 = (logintype) => {
  if (logintype) {
    localStorage.setItem('logintype', logintype);
  } else {
    localStorage.removeItem('logintype');
  }
};
// ==============================|| JWT CONTEXT & PROVIDER ||============================== //
const JWTContext3 = createContext(null);

export const JWTProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    const init = async () => {
      try {
        const serviceToken = localStorage.getItem('serviceToken');
        const user = localStorage.getItem('user');
        if (serviceToken && verifyToken(serviceToken)) {
          setSession(serviceToken);
          // const response = await axios.get('/api/account/me');
          // const { user } = response.data;
          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              user
            }
          });
        } else {
          dispatch({
            type: LOGOUT
          });
        }
      } catch (err) {
        dispatch({
          type: LOGOUT
        });
      }
    };
    init();
  }, []);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn === 'true') {
      dispatch({
        type: LOGIN,
        payload: {
          isLoggedIn: true,
          user: null // You might want to fetch the user info here if needed
        }
      });
    }
  }, []);

  const loginmobile = async (mobile, country) => {

    const response = await axios.post(`${APP_DEFAULT_PATH_BASE_URL}api/lcdw/lcdw-get-mobile`, { mobile, country });
    const { user, logintype, token } = response.data;

    // console.log('user', user);
    // console.log('token', token);

    setSession(token);
    setSession2(logintype);

    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user
      }
    });

      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('Active', user.is_deleted);
      localStorage.setItem('user_name', user.user_name);
      localStorage.setItem('user_type', user.login_type);
      localStorage.setItem('email', user.email);
      localStorage.setItem('user', JSON.stringify(user));
      
  };

  const login = async (email, password, serviceToken) => {
    if (password === '') {
      try {
        const response = await axios.post(`${APP_DEFAULT_PATH_BASE_URL}api/lcdw/lcdw-get-email`, { email });
        const { user, logintype } = response.data;

        setSession(serviceToken);
        setSession2(logintype);

        dispatch({
          type: LOGIN,
          payload: {
            isLoggedIn: true,
            user
          }
        });

          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('Active', user.is_deleted);
          localStorage.setItem('user_name', user.user_name);
          localStorage.setItem('user_type', user.login_type);
          localStorage.setItem('email', user.email);
          localStorage.setItem('user', JSON.stringify(user));
      } catch (error) {
        // console.log(error);
        throw {
          error: error.error || 'An unexpected error occurred',
          status: error?.status,
          data: error?.data
        };
      }
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      try {
        const response = await axios.post(`${APP_DEFAULT_PATH_BASE_URL}api/lcdw/lcdw-signin`, { email, password });
        if (response.data.success) {
          // console.log('response', response);
          // process.exit();
          const { user, logintype } = response.data;
          setSession(serviceToken);
          setSession2(logintype);

          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              user
            }
          });

          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('Active', user.is_deleted);
          localStorage.setItem('user_name', user.user_name);
          localStorage.setItem('user_type', user.login_type);
          localStorage.setItem('email', user.email);
          localStorage.setItem('user', JSON.stringify(user));
        } else {
          // console.log('response company false', response);
          throw {
            error: response.data.error,
            data: response.data.data
          };
        }
      } catch (error) {
        // console.error('Error during login:', error);
        throw {
          error: error.error || 'An error occurred. Please check your network and try again.',
          data: error.data
        };
      }
    }
    // Save login state to local storage
  };

  const register = async (email, password, firstName, lastName) => {
    // todo: this flow need to be recode as it not verified
    const id = chance.bb_pin();
    const response = await axios.post('/api/account/register', {
      id,
      email,
      password,
      firstName,
      lastName
    });
    let users = response.data;
    if (window.localStorage.getItem('users') !== undefined && window.localStorage.getItem('users') !== null) {
      const localUsers = window.localStorage.getItem('users');
      users = [
        ...JSON.parse(localUsers),
        {
          id,
          email,
          password,
          name: `${firstName} ${lastName}`
        }
      ];
    }
    window.localStorage.setItem('users', JSON.stringify(users));
  };

  const logout = async (email) => {
    try {
      // Send a POST request to the backend logout endpoint with the email
      await axios.post(`${APP_DEFAULT_PATH_BASE_URL}api/lcdw/lcdw-logout`, { email });
    } catch (error) {
      console.error('Error logging out:', error);
    }

    // Clear session and localStorage
    setSession(null);
    setSession2(null);
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('user');
    localStorage.removeItem('Active');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_type');
    localStorage.removeItem('email');
    dispatch({ type: LOGOUT });
  };

  const resetPassword = async () => {};
  const updateProfile = () => {};
  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }
  return (
    <JWTContext3.Provider value={{ ...state, login, logout, register, loginmobile, resetPassword, updateProfile }}>
      {children}
    </JWTContext3.Provider>
  );
};
JWTProvider.propTypes = {
  children: PropTypes.node
};
export default JWTContext3;
